import React from "react";
import cartSvg from "../assets/images/icons/cart.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { styled } from "@mui/material/styles";
import Badge, { badgeClasses } from "@mui/material/Badge";
import "../assets/Styles/mainStyle.scss";
import { getDomainInfo } from "../utils/utils";
import { useState, useEffect } from "react";

function ViewCartButton() {
  const storeId = localStorage.getItem("storeid");
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const [cartLength, setCartLength] = useState(0);
  const cart =
    useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];

    const userPhone = useSelector((state) => state.fetchUser?.user?.phone);
 
 
//  console.log(cart,'cart')
 
    const updateCartLength = () => {
    setCartLength(cart.filter((item) => item.storeid === userid).length);
  };
  useEffect(() => {
      updateCartLength();
  }, [cart]);
  const navigate = useNavigate();
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);

  if (cartLength === 0) {
    return null;
  }
  return (
    <>
    <button
      className="btn viewCartButton"
      id="cartbtn"
      onClick={() => {
        navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
        setTimeout(() => window.location.reload(), 100);
      }}

    >
      <div className="position-relative">
        <ShoppingCartOutlinedIcon
          fontSize="large"
          style={{
            marginTop: 6,
          }}
        />
        <CartBadge
          badgeContent={cartLength}
          overlap="circular"
          className="custom-badge"
        />
      </div>
    </button>
    {}
    </>
  );
}
const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: -6px;
  }
`;
export default ViewCartButton;
